module.exports = __webpack_public_path__ + "img/BannerPortabilidad600x350px.60ee31b1.jpg";